import initAds from './initAds'
import { initDfpDynamicSlot } from '../../../config/adInjectedDfpDynamicSlotConfig'

export default function initGoogleAds() {
  // initDfpDynamicSlot()
  initAds()
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/initializers/ads/initGoogleAds.js